import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import type { JiraItemSyncStatus } from '@/domain/models/development.js';

interface Props {
    status: JiraItemSyncStatus;
    sendingLabel: string;
    retryLabel: string;
}

export function JiraSolicitationStatus({ status, sendingLabel, retryLabel }: Props) {
    if (status === 'PENDING') {
        return (
            <Box data-testid="jira-solicitation-status" sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                <CircularProgress size={14} data-testid="jira-solicitation-status-loader" />
                <Typography variant="caption">{sendingLabel}</Typography>
            </Box>
        );
    }
    if (status === 'RETRYING') {
        return (
            <Typography variant="caption" data-testid="jira-solicitation-status" sx={{ display: 'block', mt: 0.5 }}>
                {retryLabel}
            </Typography>
        );
    }
    return null;
}
